export const SCHOOL_FEES = [
  { category: 'BSP/GSP', amount: 50 },
  { category: 'Anti TB', amount: 5 },
  { category: 'Red Cross', amount: 60 },
  { category: 'School Paper', amount: 90 },
  { category: 'Sports', amount: 30 },
  { category: 'Library', amount: 5 },
  { category: 'Cultural', amount: 10 },
  { category: 'Drum & Lyre', amount: 20 },
  { category: 'SSLG', amount: 50 },
  { category: 'PTA', amount: 100 },
  { category: 'BKD', amount: 10 },
  { category: 'Yes O/Science Club', amount: 10 },
  { category: 'Clinic', amount: 5 },
  { category: 'Red Cross Youth Council', amount: 10 },
  { category: 'FOT (Festival of Talents)', amount: 15 },
  { category: 'YECS', amount: 10 },
];

export const TOTAL_SCHOOL_FEE = SCHOOL_FEES.reduce((sum, fee) => sum + fee.amount, 0);

// The ₱100 discount waives the PTA contribution: the student's PTA line is recorded as ₱0, so every
// fee is still covered but the total drops by ₱100 (₱480 - ₱100 = ₱380).
export const DISCOUNT_AMOUNT = 100;
export const PTA_CATEGORY = 'PTA';
export const isWaived = (payment) => payment?.category === PTA_CATEGORY && Number(payment.amount) === 0;

// Earlier discounts were saved as a separate negative "Discount" line. Those rows still exist,
// so the totals keep recognising them.
export const DISCOUNT_CATEGORY = 'Discount';
export const isDiscount = (payment) => payment?.category === DISCOUNT_CATEGORY;
